(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6634],{

/***/ 72882:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TableContainer_TableContainer; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/base/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(27192);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js + 1 modules
var useThemeProps = __webpack_require__(33616);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js + 2 modules
var styled = __webpack_require__(11496);
// EXTERNAL MODULE: ./node_modules/@mui/base/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(28979);
// EXTERNAL MODULE: ./node_modules/@mui/base/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(76087);
;// CONCATENATED MODULE: ./node_modules/@mui/material/TableContainer/tableContainerClasses.js

function getTableContainerUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiTableContainer', slot);
}
const tableContainerClasses = (0,generateUtilityClasses/* default */.Z)('MuiTableContainer', ['root']);
/* harmony default export */ var TableContainer_tableContainerClasses = ((/* unused pure expression or super */ null && (tableContainerClasses)));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/TableContainer/TableContainer.js


const _excluded = ["className", "component"];









const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return (0,composeClasses/* default */.Z)(slots, getTableContainerUtilityClass, classes);
};

const TableContainerRoot = (0,styled/* default */.ZP)('div', {
  name: 'MuiTableContainer',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({
  width: '100%',
  overflowX: 'auto'
});
const TableContainer = /*#__PURE__*/react.forwardRef(function TableContainer(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiTableContainer'
  });

  const {
    className,
    component = 'div'
  } = props,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);

  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    component
  });

  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(TableContainerRoot, (0,esm_extends/* default */.Z)({
    ref: ref,
    as: component,
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    ownerState: ownerState
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var TableContainer_TableContainer = (TableContainer);

/***/ }),

/***/ 53184:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TableHead_TableHead; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/base/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(27192);
// EXTERNAL MODULE: ./node_modules/@mui/material/Table/Tablelvl2Context.js
var Tablelvl2Context = __webpack_require__(44063);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js + 1 modules
var useThemeProps = __webpack_require__(33616);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js + 2 modules
var styled = __webpack_require__(11496);
// EXTERNAL MODULE: ./node_modules/@mui/base/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(28979);
// EXTERNAL MODULE: ./node_modules/@mui/base/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(76087);
;// CONCATENATED MODULE: ./node_modules/@mui/material/TableHead/tableHeadClasses.js

function getTableHeadUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiTableHead', slot);
}
const tableHeadClasses = (0,generateUtilityClasses/* default */.Z)('MuiTableHead', ['root']);
/* harmony default export */ var TableHead_tableHeadClasses = ((/* unused pure expression or super */ null && (tableHeadClasses)));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/TableHead/TableHead.js


const _excluded = ["className", "component"];










const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return (0,composeClasses/* default */.Z)(slots, getTableHeadUtilityClass, classes);
};

const TableHeadRoot = (0,styled/* default */.ZP)('thead', {
  name: 'MuiTableHead',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({
  display: 'table-header-group'
});
const tablelvl2 = {
  variant: 'head'
};
const defaultComponent = 'thead';
const TableHead = /*#__PURE__*/react.forwardRef(function TableHead(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiTableHead'
  });

  const {
    className,
    component = defaultComponent
  } = props,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);

  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    component
  });

  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Tablelvl2Context/* default.Provider */.Z.Provider, {
    value: tablelvl2,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(TableHeadRoot, (0,esm_extends/* default */.Z)({
      as: component,
      className: (0,clsx_m/* default */.Z)(classes.root, className),
      ref: ref,
      role: component === defaultComponent ? null : 'rowgroup',
      ownerState: ownerState
    }, other))
  });
});
 false ? 0 : void 0;
/* harmony default export */ var TableHead_TableHead = (TableHead);

/***/ }),

/***/ 11294:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ranking",
      function () {
        return __webpack_require__(78658);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 78658:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Index; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/Container/Container.js + 1 modules
var Container = __webpack_require__(27948);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Divider/Divider.js
var Divider = __webpack_require__(67720);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js + 2 modules
var styled = __webpack_require__(11496);
// EXTERNAL MODULE: ./src/layouts/index.js + 23 modules
var layouts = __webpack_require__(23954);
// EXTERNAL MODULE: ./src/components/Page.js
var Page = __webpack_require__(82771);
// EXTERNAL MODULE: ./src/hooks/useLocales.js + 5 modules
var useLocales = __webpack_require__(9671);
// EXTERNAL MODULE: ./src/hooks/useSettings.js
var useSettings = __webpack_require__(40571);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@mui/material/Card/Card.js + 1 modules
var Card = __webpack_require__(66242);
// EXTERNAL MODULE: ./node_modules/@mui/material/Tabs/Tabs.js + 6 modules
var Tabs = __webpack_require__(88409);
// EXTERNAL MODULE: ./node_modules/@mui/material/Tab/Tab.js + 1 modules
var Tab = __webpack_require__(40044);
// EXTERNAL MODULE: ./node_modules/@mui/material/TableContainer/TableContainer.js + 1 modules
var TableContainer = __webpack_require__(72882);
// EXTERNAL MODULE: ./node_modules/@mui/material/Table/Table.js + 1 modules
var Table = __webpack_require__(7906);
// EXTERNAL MODULE: ./node_modules/@mui/material/TableHead/TableHead.js + 1 modules
var TableHead = __webpack_require__(53184);
// EXTERNAL MODULE: ./node_modules/@mui/material/TableRow/TableRow.js + 1 modules
var TableRow = __webpack_require__(53816);
// EXTERNAL MODULE: ./node_modules/@mui/material/TableCell/TableCell.js + 1 modules
var TableCell = __webpack_require__(53252);
// EXTERNAL MODULE: ./node_modules/@mui/material/TableBody/TableBody.js + 1 modules
var TableBody = __webpack_require__(295);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(87357);
// EXTERNAL MODULE: ./node_modules/@mui/material/Avatar/Avatar.js + 1 modules
var Avatar = __webpack_require__(87952);
// EXTERNAL MODULE: ./node_modules/@mui/material/TablePagination/TablePagination.js + 2 modules
var TablePagination = __webpack_require__(27110);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./src/components/Iconify.js + 1 modules
var Iconify = __webpack_require__(34444);
// EXTERNAL MODULE: ./src/components/Scrollbar.js + 26 modules
var Scrollbar = __webpack_require__(91045);
// EXTERNAL MODULE: ./src/redux/slices/hackerthon/hackerthon.user.js
var hackerthon_user = __webpack_require__(27259);
// EXTERNAL MODULE: ./src/utils/formatNumber.js
var formatNumber = __webpack_require__(87850);
// EXTERNAL MODULE: ./src/utils/formatTime.js
var formatTime = __webpack_require__(55267);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js
var Stack = __webpack_require__(26447);
// EXTERNAL MODULE: ./node_modules/@mui/material/Autocomplete/Autocomplete.js + 2 modules
var Autocomplete = __webpack_require__(78364);
// EXTERNAL MODULE: ./node_modules/@mui/material/Chip/Chip.js + 2 modules
var Chip = __webpack_require__(87918);
// EXTERNAL MODULE: ./node_modules/@mui/material/TextField/TextField.js + 1 modules
var TextField = __webpack_require__(50135);
// EXTERNAL MODULE: ./src/redux/slices/hackerthon/hackerthon.tag.js + 1 modules
var hackerthon_tag = __webpack_require__(41870);
;// CONCATENATED MODULE: ./src/sections/ranking/RankingTableToolBar.js
/* eslint-disable react-hooks/exhaustive-deps */ /* eslint-disable react/prop-types */ 




// components




// ----------------------------------------------------------------------
function RankingTableToolbar(param) {
    var filterName = param.filterName, onFilterName = param.onFilterName, onChangeTag = param.onChangeTag, selectedTag = param.selectedTag;
    var translate = (0,useLocales/* default */.Z)().translate;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,es/* useSelector */.v9)(function(state) {
        return state.hackerthonTag;
    }), tags = ref.tags, searchTag = ref.search, isLoading = ref.isLoading;
    (0,react.useEffect)(function() {
        var timeout = setTimeout(function() {
            dispatch((0,hackerthon_tag/* getTags */.NJ)());
        }, 500);
        return function() {
            return clearTimeout(timeout);
        };
    }, [
        searchTag
    ]);
    var handleFilterTags = function(_, value) {
        dispatch((0,hackerthon_tag/* setTagSearch */.tx)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, searchTag), {
            value: value
        })));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
        spacing: 2,
        direction: {
            xs: "column",
            md: "row"
        },
        sx: {
            py: 2.5,
            px: 2
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Autocomplete/* default */.Z, {
            sx: {
                minWidth: {
                    md: 300
                }
            },
            onChange: function(_, newValue) {
                return onChangeTag(newValue);
            },
            options: tags === null || tags === void 0 ? void 0 : tags.filter(function(t) {
                return t.type !== "LEVEL";
            }).map(function(param) {
                var id = param.id, title = param.title, type = param.type, exerciseNo = param.exerciseNo;
                return {
                    id: id,
                    title: title,
                    type: type,
                    exerciseNo: exerciseNo
                };
            }),
            getOptionLabel: function(option) {
                return "".concat(option.title, " (").concat(option.exerciseNo, ")") || 0;
            },
            isOptionEqualToValue: function(option, value) {
                return option.id === value.id;
            },
            loading: isLoading,
            value: selectedTag || null,
            onInputChange: handleFilterTags,
            renderTags: function(value, getTagProps) {
                return value.map(function(option, index) {
                    return /*#__PURE__*/ (0,react.createElement)(Chip/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, getTagProps({
                        index: index
                    })), {
                        key: option.id,
                        size: "small",
                        label: "".concat(option.title, " (").concat(option.exerciseNo, ")")
                    }));
                });
            },
            renderInput: function(params) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, (0,_object_spread/* default */.Z)({
                    label: translate("hackerthon.exercise.topic")
                }, params));
            }
        })
    });
}

;// CONCATENATED MODULE: ./src/sections/ranking/RankingTableAuthor.js
/* eslint-disable react-hooks/exhaustive-deps */ 













// ----------------------------------------------------------------------
function RankingTableAuthor() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var translate = (0,useLocales/* default */.Z)().translate;
    var ref = (0,es/* useSelector */.v9)(function(state) {
        return state.user;
    }), topUsers = ref.topUsers, searchUser = ref.search, totalElements = ref.totalElements;
    (0,react.useEffect)(function() {
        var timeout = setTimeout(function() {
            dispatch((0,hackerthon_user/* getTopUser */.Ax)());
        }, 500);
        return function() {
            return clearTimeout(timeout);
        };
    }, [
        searchUser
    ]);
    var handleChangePage = function(_, page) {
        dispatch((0,hackerthon_user/* setUserSearch */.Qd)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, searchUser), {
            page: page
        })));
    };
    var handleChangeRowsPerPage = function(event) {
        dispatch((0,hackerthon_user/* setUserSearch */.Qd)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, searchUser), {
            page: 0,
            size: parseInt(event.target.value, 10)
        })));
    };
    var handleFilterByName = function(value) {
        dispatch((0,hackerthon_user/* setUserSearch */.Qd)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, searchUser), {
            value: value,
            page: 0
        })));
    };
    var handleFilterByTag = function(tag) {
        dispatch((0,hackerthon_user/* setUserSearch */.Qd)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, searchUser), {
            page: 0,
            tag: tag,
            filterBys: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, searchUser.filterBys), {
                tagId: tag === null || tag === void 0 ? void 0 : tag.id
            })
        })));
    };
    var TABS = [
        {
            id: 0,
            label: translate("ranking.topserver")
        },
        {
            id: 1,
            label: translate("ranking.top30days")
        },
        {
            id: 2,
            label: translate("ranking.top7days")
        }, 
    ];
    var ref1 = (0,react.useState)(0), tab = ref1[0], setTab = ref1[1];
    var handleChangeTab = function(_, newValue) {
        if (newValue === 0) {
            dispatch((0,hackerthon_user/* setUserSearch */.Qd)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, searchUser), {
                page: 0,
                filterBys: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, searchUser.filterBys), {
                    startAt: null,
                    endAt: null
                })
            })));
        } else if (newValue === 1) {
            var _now = new Date();
            var lastDate = new Date(_now.getFullYear(), _now.getMonth() - 1, _now.getDate());
            dispatch((0,hackerthon_user/* setUserSearch */.Qd)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, searchUser), {
                page: 0,
                filterBys: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, searchUser.filterBys), {
                    startAt: (0,formatTime/* fDates */.BK)(lastDate),
                    endAt: (0,formatTime/* fDates */.BK)(_now)
                })
            })));
        } else {
            var _now1 = new Date();
            var lastDate1 = new Date(_now1.getFullYear(), _now1.getMonth(), _now1.getDate() - 7);
            dispatch((0,hackerthon_user/* setUserSearch */.Qd)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, searchUser), {
                page: 0,
                filterBys: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, searchUser.filterBys), {
                    startAt: (0,formatTime/* fDates */.BK)(lastDate1),
                    endAt: (0,formatTime/* fDates */.BK)(_now1)
                })
            })));
        }
        setTab(newValue);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* default */.Z, {
                value: tab,
                onChange: handleChangeTab,
                textColor: "secondary",
                variant: "scrollable",
                scrollButtons: "auto",
                indicatorColor: "secondary",
                sx: {
                    px: 2,
                    bgcolor: "background.neutral"
                },
                children: TABS.map(function(tab) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* default */.Z, {
                        disableRipple: true,
                        value: tab.id,
                        label: tab.label
                    }, tab.id);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RankingTableToolbar, {
                onFilterName: handleFilterByName,
                filterName: searchUser.value,
                selectedTag: searchUser.tag,
                onChangeTag: handleFilterByTag
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Scrollbar/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableContainer/* default */.Z, {
                    sx: {
                        minWidth: 720
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Table/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableHead/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                            children: translate("ranking.rank")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                            children: translate("ranking.user")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                            children: translate("ranking.score")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                            children: translate("ranking.submission")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                            children: translate("ranking.rate")
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableBody/* default */.Z, {
                                children: topUsers.map(function(row, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                children: index == 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                                                    icon: "material-symbols:rewarded-ads",
                                                    sx: {
                                                        width: 30,
                                                        height: 30,
                                                        color: "#fccb2b"
                                                    }
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                    variant: "subtitle2",
                                                    children: [
                                                        "#",
                                                        index + 1,
                                                        " "
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/user/".concat(row.id),
                                                    passHref: true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                        sx: {
                                                            display: "flex",
                                                            alignItems: "center",
                                                            cursor: "pointer"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                                                alt: row.displayName,
                                                                src: row.photoURL,
                                                                sx: {
                                                                    width: 30,
                                                                    height: 30
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                                sx: {
                                                                    ml: 1
                                                                },
                                                                variant: "subtitle2",
                                                                children: [
                                                                    " ",
                                                                    row.displayName,
                                                                    " "
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                children: row.score
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                children: row.answerNo
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                    variant: "subtitle2",
                                                    children: [
                                                        " ",
                                                        (0,formatNumber/* fPercent */.f2)(row.acceptedNo * 100 / row.answerNo),
                                                        " "
                                                    ]
                                                })
                                            })
                                        ]
                                    }, index);
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TablePagination/* default */.Z, {
                rowsPerPageOptions: [
                    10,
                    25,
                    50
                ],
                component: "div",
                count: totalElements,
                rowsPerPage: searchUser.size,
                page: searchUser.page,
                onPageChange: handleChangePage,
                onRowsPerPageChange: handleChangeRowsPerPage
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/pages/ranking/index.js
// @mui




// layouts

// components

// sections



// ----------------------------------------------------------------------
var RootStyle = (0,styled/* default */.ZP)("div")(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        paddingBottom: theme.spacing(10),
        paddingTop: theme.spacing(10)
    }, theme.breakpoints.up("md"), {
        paddingTop: theme.spacing(15)
    });
});
// ----------------------------------------------------------------------
Index.getLayout = function getLayout(page) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(layouts/* default */.Z, {
        variant: "main",
        children: page
    });
};
// ----------------------------------------------------------------------
function Index() {
    var translate = (0,useLocales/* default */.Z)().translate;
    var themeStretch = (0,useSettings/* default */.Z)().themeStretch;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Page/* default */.Z, {
        title: translate("ranking.title"),
        description: translate("ranking.description"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RootStyle, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                maxWidth: themeStretch ? "xl" : "lg",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    container: true,
                    spacing: 2,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "h5",
                                children: translate("ranking.title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                                sx: {
                                    my: 1
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RankingTableAuthor, {})
                        ]
                    })
                })
            })
        })
    });
}


/***/ }),

/***/ 55267:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BK": function() { return /* binding */ fDates; },
/* harmony export */   "DY": function() { return /* binding */ fToNow; },
/* harmony export */   "xn": function() { return /* binding */ parseDateTimeSuffix; }
/* harmony export */ });
/* unused harmony exports fDate, fDateTime, fTimestamp, fDateTimeSuffix */
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32912);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83366);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2141);
/* harmony import */ var date_fns_locale__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34215);
/* harmony import */ var date_fns_locale__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95826);


// ----------------------------------------------------------------------
function fDate(date) {
    return format(new Date(date), "dd MMMM yyyy");
}
function fDates(date) {
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(new Date(date), "dd/MM/yyyy");
}
function fDateTime(date) {
    return format(new Date(date), "dd MMM yyyy p");
}
function fTimestamp(date) {
    return getTime(new Date(date));
}
function fDateTimeSuffix(date) {
    return format(new Date(date), "dd/MM/yyyy hh:mm p");
}
function parseDateTimeSuffix(dateString) {
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dateString, "dd/MM/yyyy HH:mm", new Date());
}
function fToNow(date) {
    var currentLang = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "vi";
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(new Date(date), {
        addSuffix: true,
        includeSeconds: true,
        locale: currentLang === "vi" ? date_fns_locale__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z : date_fns_locale__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5101,6429,135,6105,8364,2444,6805,9774,2888,179], function() { return __webpack_exec__(11294); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);